// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".webinar-bottom-menu {\n  z-index: 10;\n  height: 96px;\n  padding: 0 40px;\n  animation-duration: 0.3s;\n  position: relative;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.webinar-bottom-menu .menu-btn-spacer {\n  width: 10px;\n}", ""]);
// Exports
module.exports = exports;
